export default __webpack_public_path__ + "static/media/listItem1.bc182d65.svg";